import { render, staticRenderFns } from "./UploadMedia.vue?vue&type=template&id=87604aae&scoped=true&"
import script from "./UploadMedia.vue?vue&type=script&lang=js&"
export * from "./UploadMedia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87604aae",
  null
  
)

export default component.exports